import React from 'react';
import { SelectedImage, QAItemProps } from './types';
import { ProductResponse } from '../../type/web';
import QAImageItem from './QAImageItem';
import { QATextItem } from './QATextItem';

export function QAitem(props: QAItemProps) {
  const {
    tid, item, onClickAsset, onScrollToBottom,
    onOpenSmartCatalog
  } = props;
  const { type, id, question, answer, done } = item;

  if (type === 'image') {
    const imageItem = {
      type: type,
      id: id,
      question: question as SelectedImage,
      answer: answer as ProductResponse[],
      done: done,
    };

    return (
      <QAImageItem
        tid={tid}
        item={imageItem}
        onOpenSmartCatalog={onOpenSmartCatalog}
      />
    );
  }

  const textItem = {
    type: type,
    id: id,
    question: question as string,
    answer: answer as string,
    done: done,
  };

  return (
    <QATextItem
      tid={tid}
      item={textItem}
      onClickAsset={onClickAsset}
      onScrollToBottom={onScrollToBottom}
    />
  );
}
